const createElement = (html) => {
  const container = document.createElement("div");
  container.innerHTML = html;
  return container.firstElementChild;
};

export default createElement;
